// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ServicesTypesProjectDashboard from '../../components/administration/serviceTypesProject/ServicesTypeProjectDashboard';

const TiposServiciosProyectoPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <ServicesTypesProjectDashboard
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de tipos de servicios proyecto:', newOrder);
                }}
            />
        </Box>
    );
};

export default TiposServiciosProyectoPage;
